import { render, staticRenderFns } from "./order-modal-items.vue?vue&type=template&id=f5dd46fa&scoped=true"
import script from "./order-modal-items.vue?vue&type=script&lang=js"
export * from "./order-modal-items.vue?vue&type=script&lang=js"
import style0 from "./order-modal-items.vue?vue&type=style&index=0&id=f5dd46fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dd46fa",
  null
  
)

export default component.exports